import { createSvgIcon } from "@mui/material";

const DataBackupIcon = createSvgIcon(
  <svg viewBox="0 0 40 40" fill="none">
    <path
      d="M0 10.1587C0 4.54822 4.77563 0 10.6667 0H29.3333C35.2244 0 40 4.54822 40 10.1587V29.8413C40 35.4518 35.2244 40 29.3333 40H10.6667C4.77563 40 0 35.4518 0 29.8413V10.1587Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M9.5 23.3889C9.5 22.898 9.89797 22.5 10.3889 22.5H31.6111C32.102 22.5 32.5 22.898 32.5 23.3889V30.6111C32.5 31.102 32.102 31.5 31.6111 31.5H10.3889C9.89797 31.5 9.5 31.102 9.5 30.6111V23.3889Z"
      fill="#B2EBF2"
    />
    <path
      d="M9.5 11.3889C9.5 10.898 9.89797 10.5 10.3889 10.5H31.6111C32.102 10.5 32.5 10.898 32.5 11.3889V18.6111C32.5 19.102 32.102 19.5 31.6111 19.5H10.3889C9.89797 19.5 9.5 19.102 9.5 18.6111V11.3889Z"
      fill="#B2EBF2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.22217 21.3889C7.22217 20.4684 7.96836 19.7222 8.88883 19.7222H30.1111C31.0315 19.7222 31.7777 20.4684 31.7777 21.3889V29.1111C31.7777 30.0316 31.0315 30.7778 30.1111 30.7778H8.88883C7.96836 30.7778 7.22217 30.0316 7.22217 29.1111V21.3889ZM8.88883 21.2778C8.82747 21.2778 8.77772 21.3275 8.77772 21.3889V29.1111C8.77772 29.1725 8.82747 29.2222 8.88883 29.2222H30.1111C30.1724 29.2222 30.2222 29.1725 30.2222 29.1111V21.3889C30.2222 21.3275 30.1724 21.2778 30.1111 21.2778H8.88883Z"
      fill="#29A2B1"
    />
    <path
      d="M13.1174 25.3087C13.1174 26.0315 12.5315 26.6174 11.8087 26.6174C11.0859 26.6174 10.5 26.0315 10.5 25.3087C10.5 24.5859 11.0859 24 11.8087 24C12.5315 24 13.1174 24.5859 13.1174 25.3087Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9999 22.7222C25.4295 22.7222 25.7777 23.0705 25.7777 23.5V27.041C25.7777 27.4705 25.4295 27.8188 24.9999 27.8188C24.5704 27.8188 24.2222 27.4705 24.2222 27.041V23.5C24.2222 23.0705 24.5704 22.7222 24.9999 22.7222Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.0236 22.7222C28.4532 22.7222 28.8014 23.0705 28.8014 23.5V27.041C28.8014 27.4705 28.4532 27.8188 28.0236 27.8188C27.5941 27.8188 27.2458 27.4705 27.2458 27.041V23.5C27.2458 23.0705 27.5941 22.7222 28.0236 22.7222Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.22217 9.3889C7.22217 8.46842 7.96836 7.72223 8.88883 7.72223H30.1111C31.0315 7.72223 31.7777 8.46842 31.7777 9.3889V17.1111C31.7777 18.0316 31.0315 18.7778 30.1111 18.7778H8.88883C7.96836 18.7778 7.22217 18.0316 7.22217 17.1111V9.3889ZM8.88883 9.27778C8.82747 9.27778 8.77772 9.32753 8.77772 9.3889V17.1111C8.77772 17.1725 8.82747 17.2222 8.88883 17.2222H30.1111C30.1724 17.2222 30.2222 17.1725 30.2222 17.1111V9.3889C30.2222 9.32753 30.1724 9.27778 30.1111 9.27778H8.88883Z"
      fill="#29A2B1"
    />
    <path
      d="M13.1174 13.3087C13.1174 14.0315 12.5315 14.6174 11.8087 14.6174C11.0859 14.6174 10.5 14.0315 10.5 13.3087C10.5 12.5859 11.0859 12 11.8087 12C12.5315 12 13.1174 12.5859 13.1174 13.3087Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9999 10.7222C25.4295 10.7222 25.7777 11.0705 25.7777 11.5V15.041C25.7777 15.4705 25.4295 15.8188 24.9999 15.8188C24.5704 15.8188 24.2222 15.4705 24.2222 15.041V11.5C24.2222 11.0705 24.5704 10.7222 24.9999 10.7222Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.0236 10.7222C28.4532 10.7222 28.8014 11.0705 28.8014 11.5V15.041C28.8014 15.4705 28.4532 15.8188 28.0236 15.8188C27.5941 15.8188 27.2458 15.4705 27.2458 15.041V11.5C27.2458 11.0705 27.5941 10.7222 28.0236 10.7222Z"
      fill="#29A2B1"
    />
  </svg>,
  "DataBackupIcon"
);

export default DataBackupIcon;
